import BaseInput from 'flow/components/ui-components/BaseInput';
import AppContext from 'flow/contexts/app-context';
import { isValidSaveableNumber } from 'flow/utils/call-utils';
import { Map } from 'immutable';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import PropTypes from 'prop-types';
import React from 'react';
import PhoneNumberInput from 'react-phone-number-input';

import 'react-phone-number-input/style.css';
import './css/phoneInputCountry.css';

const InputComponent = React.forwardRef(function InputComponent(props, ref) {
    const { value, onChange } = props;
    return (
        <BaseInput
            value={value}
            onChange={onChange}
            ref={ref}
            noMarginTop={true}
        />
    );
});

InputComponent.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
};

class NumberFieldSmart extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string,
        numberDTO: PropTypes.instanceOf(Map),
        onBlur: PropTypes.func,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        label: PropTypes.string,
        defaultCountryCode: PropTypes.string,
    };

    static contextType = AppContext;

    constructor(props) {
        super(props);

        const { numberDTO } = props;
        const number = numberDTO ? numberDTO.get('number', '') : '';

        //Superduper naive check
        const isShortNumber =
            numberDTO &&
            numberDTO.get('type') === 'missing_context' &&
            numberDTO.get('nationalFormat') &&
            numberDTO.get('nationalFormat').length <= 5;

        //Naive approach to formatting numbers for a few select countries.
        const formattedNumber = number.replace(
            /^00(358|41|44|45|46|47|97)/,
            '+$1',
        );

        this.state = {
            enteredNumber: formattedNumber,
            indicateInvalid: false,
            isShortNumber: isShortNumber,
            numberIsValid: isValidSaveableNumber(formattedNumber),
        };
    }

    handleNumberChangeSmart = (phoneNumber) => {
        const { onChange } = this.props;

        this.setState({
            enteredNumber: phoneNumber,
            numberIsValid: isValidSaveableNumber(phoneNumber),
        });

        if (onChange && isValidSaveableNumber(phoneNumber)) {
            onChange(this.props.id, phoneNumber);
        }
    };

    handleNumberChange = (event) => {
        const { onChange } = this.props;
        this.setState({
            enteredNumber: event.target.value,
            numberIsValid: isValidSaveableNumber(event.target.value),
        });

        if (onChange && isValidSaveableNumber(event.target.value)) {
            onChange(this.props.id, event.target.value);
        }
    };

    numberFieldFocused = () => {
        this.setState({
            indicateInvalid: false,
        });
    };

    render() {
        const { id, onBlur, disabled, label, defaultCountryCode, numberDTO } =
            this.props;
        const { enteredNumber, numberIsValid, isShortNumber } = this.state;
        const { i18next } = this.context;

        const defaultValue = enteredNumber;
        const shouldDisplayInternationlOption =
            numberDTO?.get('type') === 'missing_context';

        const errorText = numberIsValid
            ? ''
            : i18next.t('fields.phonenumber.format.error');
        const hintText = i18next.t('InviteColleagues.TokenField.Input');

        const fieldLabel = label ? label : null;

        if (disabled || isShortNumber) {
            const numberFieldProps = {
                defaultValue,
                disabled,
                error: !!errorText,
                placeholder: disabled ? '' : hintText,
                id,
                onBlur,
                fullWidth: true,
                onChange: this.handleNumberChange,
                label: fieldLabel,
            };

            return (
                <div className="flex flex-col justify-center gap-1">
                    <BaseInput
                        dir="ltr"
                        className="rtl:text-end"
                        {...numberFieldProps}
                    />
                    {errorText ? (
                        <p className="text-sm text-gray-500">{errorText}</p>
                    ) : null}
                </div>
            );
        }
        let countryCode = undefined;

        if (numberDTO && numberDTO.get('number')) {
            const parsedNumber = defaultValue
                ? parsePhoneNumberFromString(defaultValue)
                : null;
            countryCode = numberDTO.get('countryCode')
                ? numberDTO.get('countryCode')
                : defaultValue && parsedNumber && parsedNumber.isValid()
                  ? parsedNumber.country.toUpperCase()
                  : undefined;
        } else {
            countryCode =
                defaultCountryCode !== undefined
                    ? defaultCountryCode.toUpperCase()
                    : undefined;
        }

        return (
            <div className="flex flex-col justify-center">
                <div className="block text-start text-xs/6 text-gray-900">
                    {fieldLabel}
                </div>
                <div className="PhoneNumberParent">
                    <PhoneNumberInput
                        placeholder={hintText}
                        value={defaultValue}
                        defaultCountry={countryCode}
                        disabled={disabled}
                        onChange={this.handleNumberChangeSmart}
                        onFocus={this.numberFieldFocused}
                        inputComponent={InputComponent}
                        addInternationalOption={shouldDisplayInternationlOption}
                    />
                </div>
            </div>
        );
    }
}

export default NumberFieldSmart;
